export default __webpack_public_path__ + "static/media/md-card-bg-python-aiml.0817bbd9.png";